import React, { Fragment, useEffect } from 'react';
import Helmet from 'react-helmet';
import { FormattedMessage } from 'react-intl';
import get from 'lodash/get';
import { compose } from 'recompose';
import { useSegmentClient } from '@redbubble/react-segment';
import PageSection from '@redbubble/design-system/react/PageSection';
import Box from '@redbubble/design-system/react/Box';
import Text from '@redbubble/design-system/react/Text';
import * as constants from '@redbubble/design-system/react/constants';

import { useAnalyticsActions } from '../../containers/redux/withAnalytics';
import { useBrowserInfo } from '../../containers/redux/withBrowserInfo';
import withUserInfo from '../../containers/apollo/withUserInfo';
import withLocaleRedirect from '../../containers/withLocaleRedirect';
import WorkRecommendationFeed from '../WorkRecommendationFeedGrid';
import ExploreTabs from '../ExploreTabs';
import useSendImpressions from '../../hooks/useSendImpressions';
import { EXPLORE_FEED_LABEL, analyticsPayload } from '../../lib/analytics';
import messages from './messages';
import { withExperimentContext } from '../../contexts/Experiment';

const WorkRecommendationFeedGrid = withExperimentContext(
  WorkRecommendationFeed
);

const ExploreFeed = ({ userInfo }) => {
  const browser = useBrowserInfo();
  const { logEvent } = useAnalyticsActions();
  const segmentClient = useSegmentClient();

  useSendImpressions();
  useEffect(() => {
    const { currency, locale, country } = userInfo;
    segmentClient.page('Explore', { currency, locale, country });
  }, []);

  const locale = get(userInfo, 'locale', 'en');
  const logComponentInView = (componentName, loading) => () => {
    logEvent({
      analytics: analyticsPayload.componentShowedInExplorePage(
        componentName,
        loading
      )
    });
  };

  const desktop = !!browser.is.large;
  const profile = desktop ? constants.DESKTOP : constants.MOBILE;
  const padding = desktop ? 2 : 1;
  const pageSectionProps = {
    backgroundColor: constants.COLOR_WHITE,
    profile,
    padding,
    size: constants.MEDIUM
  };

  return (
    <Fragment>
      <Helmet>
        <meta name="robots" content="noindex" />
      </Helmet>
      <PageSection {...pageSectionProps}>
        <ExploreTabs locale={locale} currentPath="/explore/feed" />
        <Box
          display="flex"
          justifyContent="space-between"
          marginBottom={browser.is.small ? 1 : 1.5}
        >
          <Text type="display2" element="h2" block>
            <FormattedMessage {...messages.feedTitle} />
          </Text>
        </Box>
        <WorkRecommendationFeedGrid
          browser={browser}
          analyticsLabel={EXPLORE_FEED_LABEL}
          logComponentInView={logComponentInView}
          userInfo={userInfo}
        />
      </PageSection>
    </Fragment>
  );
};

export default compose(
  withUserInfo,
  withLocaleRedirect
)(ExploreFeed);
